import { useEffect, useState } from 'react'

import { api } from '../lib/api'

export function usePhotoUrl(id: string | undefined): string | undefined {
  const [url, setUrl] = useState<string>()

  useEffect(() => {
    if (!id) return undefined
    let revoked = false
    let objectUrl = ''

    void api
      .photoBlob(id)
      .then((blob) => {
        if (revoked) return undefined
        objectUrl = URL.createObjectURL(blob)
        setUrl(objectUrl)
        return objectUrl
      })
      .catch(() => setUrl(undefined))

    return () => {
      revoked = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [id])

  return url
}

export function PhotoImage({
  id,
  alt,
  className,
}: {
  id: string
  alt: string
  className?: string
}) {
  const url = usePhotoUrl(id)

  return (
    <div className={`overflow-hidden rounded-nested bg-fill ${className ?? ''}`}>
      {url ? <img src={url} alt={alt} className="h-full w-full object-cover" /> : null}
    </div>
  )
}
